export default __webpack_public_path__ + "static/media/sakshi.6f6ae92e.svg";